import { render } from "./ArticleHeader.vue?vue&type=template&id=12066e79"
import script from "./ArticleHeader.vue?vue&type=script&lang=js"
export * from "./ArticleHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__